import { render, staticRenderFns } from "./ContentFeedLikes.vue?vue&type=template&id=31fd2d18&scoped=true&"
import script from "./ContentFeedLikes.vue?vue&type=script&lang=ts&"
export * from "./ContentFeedLikes.vue?vue&type=script&lang=ts&"
import style0 from "./ContentFeedLikes.vue?vue&type=style&index=0&id=31fd2d18&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fd2d18",
  null
  
)

export default component.exports